import {
  ACTIVE_PROFILE_STORAGE_KEY,
  EMPTY_PROFILES_STATE,
  PROFILES_STATE_BROADCAST_CHANNEL,
  PROFILES_STATE_STORAGE_KEY,
  STATUS,
} from '@/constants';
import { PL_LOG_GROUPS, logger } from '@/utils';
import { LOG_LEVEL, type StoreCoreControls, createStore, storage } from '@b2x/shared';
import { api } from './api';

export type StoreControls = StoreCoreControls<typeof profilesStore>;

export const profilesStore = createStore({
  initialState: EMPTY_PROFILES_STATE,
  owner: 'iam',
  derived: {
    hasError: ({ meta }) => meta.status === STATUS.FAILURE,
    isPending: ({ meta }) => meta.status === STATUS.INITIAL,
  },
  api,
  options: {
    enableUsageTracking: true,
    tabSync: {
      enable: true,
      key: PROFILES_STATE_BROADCAST_CHANNEL,
    },
    defaultShallow: true,
    persistence: {
      key: PROFILES_STATE_STORAGE_KEY,
      storage: sessionStorage,
    },
    events: {
      onState: ({ nextState }) => {
        const { businessType, id } = nextState.activeProfile;
        storage.local.set(ACTIVE_PROFILE_STORAGE_KEY, { businessType, id });
        logger('Profiles State changed', {
          args: [nextState],
          group: PL_LOG_GROUPS.STORE,
          level: LOG_LEVEL.LOG,
        });
      },
      onError: ({ error, context }) => {
        logger(`${context.message || 'Error in store'}`, {
          args: [error, context],
          group: PL_LOG_GROUPS.STORE,
          level: LOG_LEVEL.ERROR,
        });
      },
    },
  },
});
